import { Typography, TypographyProps } from "@mui/material";

export type EventCardDateProps = { date: string } & TypographyProps

export const EventCardDate: React.FC<EventCardDateProps> = ({ date, ...props }) => {
    return <Typography variant="label2" textTransform="uppercase" color="text.secondary" {...props}>
        {date}
    </Typography>;
}; 
